export const FETCH_REFDATA_REQUEST = 'REFDATA/CONFIG/FETCH_REQUEST';
export const FETCH_REFDATA_SUCCESS = 'REFDATA/CONFIG/FETCH_SUCCESS';
export const FETCH_REFDATA_FAILURE = 'REFDATA/CONFIG/FETCH_FAILURE';
